import { ClientApi } from "@/api/ClientApi";
import { ZoneApi } from "@/api/ZoneApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { REPORT_FORMATS, REPORT_PRINT_FORMAT } from "@utils/Constants";

const ClientSettlementsReportFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "clientId",
                        "label": "Cliente",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const clients = await ClientApi.optionsList();
                            return {
                                "-2": "Todos los Clientes",
                                ...clients
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "zoneId",
                        "label": "Zona de Cliente",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const zones = await ZoneApi.optionsList();
                            return {
                                "-2": "Todos las Zonas",
                                ...zones
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "startDate",
                        "label": "Fecha Inicio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4,
                            "lg": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "endDate",
                        "label": "Fecha Fin",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4,
                            "lg": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "format",
                        "label": "Formato",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": REPORT_FORMATS,
                        "defaultValue": REPORT_PRINT_FORMAT,
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "excludeAnuladas",
                        "label": "Excluir liquidaciones anuladas",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        },
                        "defaultValue": false,
                    }
                ],
            ]
        }
    ],
};

export default ClientSettlementsReportFormConfig;
